var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-info mt-3 mw",on:{"click":_vm.send}},[_vm._v("\n    "+_vm._s(_vm._f("setText")("next","Далее"))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }